import { DateTime } from 'luxon';
import React from 'react'
import { ReactComponent as Check } from "../../../assets/new-icons/check_simple.svg";

function CardYear({data}) {
    return (
        <div className="year_card">
            <div className="year_card-top">
                <div className="year_card-top_icon"><Check /></div>
                <p className="year_card-top_label">{DateTime.fromISO(data.data_competenza).toFormat('MMMM')}</p>
            </div>
            <div className="year_card-middle">
                <div className="year_card-middle_box">
                    <div className="year_card-middle_box-label">Prezzo</div>
                    <div className="year_card-middle_box-main">{parseFloat(data.entry_price).toFixed(2).replace(/\./g, ",")} €</div>
                </div>
                <div className="year_card-middle_box">
                    <div className="year_card-middle_box-label">kWh</div>
                    <div className="year_card-middle_box-main">{parseFloat(data.entry_kwh).toFixed(2).replace(/\./g, ",")}</div>
                </div>
            </div>
            <div className="year_card-bottom">
                <p className="year_card-bottom_label">Consumi</p>
                <p className="year_card-bottom_main">{parseFloat(data.entry_amount).toFixed(2).replace(/\./g, ",")}€</p>
            </div>
        </div>
    )
}

export default CardYear